<script>
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import Vue from 'vue'

export default {
  components: {},
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      step: 0,
      dontShowAgain: false,
      items: [
        {
          title: 'Boas-vindas!',
          img: [
            'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/boas-vindas-1.png',
          ],
          description: `Seguindo nossa cultura de melhoria constante, apresentamos a nova versão da plataforma para você.
          Redesenhamos a usabilidade e as principais telas do sistema, proporcionando maior dinamismo e gestão visual para informações apresentadas.
          <br/>Veja as novidades:`,
        },
        {
          title: 'Controladoria Financeira',
          img: [
            'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/controladoria-financeira-1.png',
            'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/controladoria-financeira-2.png',
          ],
          description: `Na <b>controladoria financeira</b>, aprofundamos a análise dos demonstrativos e facilitamos as opções de filtros e visualizações por período, filial, segmentação e profissional.
          Agora você possui os dois principais demonstrativos na sua plataforma whitelabel: DRE (demonstrativo de resultado de exercício – gerencial) e DFC (demonstrativo de fluxo de caixa).
          Em breve apresentaremos nossos serviços de contabilidade e anexaremos o BP (balanço patrimonial) em seu whitelabel.`,
        },
        {
          title: 'Resultado Financeiro',
          img: [
            'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/resultado-financeiro-1.png',
            'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/resultado-financeiro-2.png',
          ],
          description:
            'Nesta tela, você conseguirá ver os principais indicadores do seu Escritório.',
        },
        {
          title: 'Partnership',
          img: [
            'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/partnership-1.png',
            // 'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/partnership-2.png',
            'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/contratos-1.png',
          ],
          description: `Quanto ao <b>partnership</b>, reestruturamos toda a tela e nos plugamos com software para assinaturas digitais, agora você consegue assinar todos os termos individuais e acordos de sócios por dentro da plataforma.
          Praticidade, pool societário e histórico por PJ e equipe no mesmo lugar!`,
        },
        // {
        //   title: 'Contratos',
        //   img: [''],
        // },
        {
          title: 'Plano de Carreira',
          img: [
            'https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/2022-10-11/carreira-1.png',
          ],
          description: `Sobre o <b>plano de carreira</b>, aprimoramos o acompanhamento da captação de cada profissional e verificar status relacionados à captação (promotor/detrator) e segmentação (aderente/não aderente).
          Veja as informações da equipe inteira ou de um assessor específico, desde a evolução da base de clientes como os resultados financeiros (ROI, receita gerada e margem de contribuição por exemplo).`,
        },
        // {
        //   title: 'Navegação',
        //   img: [],
        // },
        // crossseling
      ],
    }
  },
  created() {
    GlobalBus.$on(MODAL.RELEASE_NOTES, this.open)
    this.busModal.$on('close', this.onClose)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.RELEASE_NOTES, this.open)
    if (this.busModal) {
      this.busModal.$off('close', this.onClose)
    }
  },
  methods: {
    open() {
      if (!this.$currentUser().IS_CLIENTE) {
        this.busModal.$emit('dialog', true)
      }
    },
    onClose() {
      this.$store.dispatch('parameters/saveConfigLocal', {
        showModalUpdates: !this.dontShowAgain,
      })
    },
  },
}
</script>

<template>
  <BaseModal
    :bus="busModal"
    max-width="85vw"
    center-screen
    content-class="modal-release"
  >
    <div
      class="d-flex flex-column"
      style="margin-top: -40px; margin-bottom: 24px"
    >
      <img
        src="@assets/images/logo-partners.svg"
        width="230"
        style="margin-bottom: 12px"
      />
      <!-- <span class="text-paragraph-medium text-black">
        Bem-vindo(a)! Estamos em constantemente atualização, veja o que temos de
        novo:
      </span> -->
      <span
        v-if="step === items.length - 1"
        class="text-paragraph-small text-color-900"
      >
        Para saber mais sobre os serviços, clique
        <a
          href="mailto:gestao@aawz.com.br"
          class="text-underline"
          target="_blank"
          >aqui</a
        >
        para falar com um de nossos consultores.
      </span>
    </div>
    <div style="position: relative">
      <v-carousel
        v-model="step"
        :show-arrows="false"
        hide-delimiters
        style="max-height: 60vh"
      >
        <v-carousel-item
          v-for="item in items"
          :key="item.title"
          style="min-height: 55vh"
        >
          <h2 class="text-heading-large text-black mb-1rem">
            {{ item.title }}
          </h2>
          <div
            v-if="item.description"
            :style="{ 'max-width': item.img.length ? '90%' : '40%' }"
            class="text-color-900 text-paragraph-medium"
          >
            <span v-html="item.description"></span>
          </div>
          <div
            class="d-flex align-items-center"
            style="
              flex-wrap: wrap;
              max-height: 90%;
              overflow: auto;
              padding: 10px;
              gap: 0.8rem;
            "
          >
            <img
              v-for="img in item.img"
              :key="img"
              :src="img"
              class="elevation-1"
              style="
                max-width: 48%;
                border-radius: 6px;
                max-height: 40vh;
                height: auto;
                width: auto;
                min-height: 200px;
              "
              :alt="item.title"
            />
          </div>
        </v-carousel-item>
      </v-carousel>
      <div
        class="d-flex align-items-center"
        style="
          position: absolute;
          bottom: -10px;
          gap: 1rem;
          left: 0;
          right: 0;
          width: fit-content;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <div
          v-for="(item, index) in items"
          :key="index"
          :style="{
            'border-radius': '50px',
            width: '12px',
            height: '12px',
            opacity: index === step ? 1 : 0.6,
            'background-color': '#e4e4e4',
            'z-index': 2,
          }"
          class="mouse-hover"
          :class="{ 'bg-primary': index === step }"
          @click="step = index"
        >
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center mt-5">
      <v-checkbox
        v-model="dontShowAgain"
        label="Não mostrar isso novamente"
        hide-details
        dense
      />
      <v-spacer />
      <v-btn text color="primary" @click="step--">
        <v-icon color="primary"> mdi-chevron-left </v-icon> Anterior
      </v-btn>
      <div class="modal-release-divider"></div>
      <v-btn text color="primary" @click="step++">
        Próximo
        <v-icon color="primary"> mdi-chevron-right </v-icon>
      </v-btn>
    </div>

    <!-- <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Sair </BaseButton>
      <v-spacer />
    </template> -->
  </BaseModal>
</template>

<style lang="sass">
.modal-release
  border-radius: 12px
  max-height: 95vh !important
  .v-card
    padding-bottom: 24px !important
    padding-right: 24px !important
    padding-top: 16px !important
    padding-left: 16px !important
  .modal-release-divider
    height: 20px
    width: 1px
    border-right: 1px solid #8e8e8e
    opacity: 0.6
</style>
